<template>
  <AppContainer>
    <section class="w-full flex flex-col items-center py-24">
      <div class="max-w-3xl text-center space-y-5">
        <p class="text-brand-secondary font-semibold text-md">Help Centre</p>
        <h1 class="text-5xl text-grey-light-900 font-semibold">Have any questions or concerns?</h1>
        <p class="text-grey-light-600 text-xl max-w-xl mx-auto">
          Browse our FAQs or contact LayUp support – our team will respond as soon as possible.
        </p>
      </div>
    </section>
    <hr />
    <section class="flex flex-col items-center py-24">
      <div class="w-full md:max-w-3xl">
        <FaqTabs :tabs="tabs" />
      </div>
    </section>
    <section class="pb-24">
      <TalkToSupport />
    </section>
  </AppContainer>
</template>

<script setup lang="ts">
import AppContainer from '@/components/AppContainer.vue';
import TalkToSupport from '@/components/call-to-actions/TalkToSupport.vue';
import FaqTabs from '@/components/FaqTabs.vue';
import questions from '@/data/faqs.json';
import { computed } from 'vue';

const tabs = computed(() => questions.find((item) => item.category === 'shopper')?.tabs || []);
</script>
